import React from 'react';
import { Row, Col } from "react-bootstrap";
import Button from '@material-ui/core/Button';
import IconHolder from '../Common/IconHolder';

export default function InsuranceCards(props) {
  return (
    <React.Fragment>
      <Row className="mb-2">
        <div className="products-container w-100 ">
          <Row className="w-100">
            <Col className='w-100 mx-2'>
              <div style={{ backgroundImage: `linear-gradient(145deg, rgb(249, 251, 253) 0%, rgb(249, 251, 253) 1%, rgba(249, 251, 253, 0) 1%) ,url(${props.backgroundImage})` }} className='background-image-class'></div>
              <div className="insurance-cards">
                <div className="d-flex">
                  <Row className={`d-flex pl-3`}>
                    <IconHolder icon={props.logo} viewBox="0 0 24 24" />
                  </Row>
                </div>
                <div className='font-size mt-3'><b>{props.cardText}</b></div>
                <Col className='pl-0 mt-4'>
                  <Button variant="contained" size="medium" color="primary" className='insurance-btn' onClick={() => props.history.push(props.location)}>
                    START
                  </Button>
                </Col>
              </div>
            </Col>
          </Row>
        </div>
      </Row>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/InsuranceCards.js